import { SegmentDimension } from "../schema/analytics";

import { IFilterWithValues } from "../../List/components/FilterModal";
import { IFilterType } from "../../List/constants/general-filter";

interface SegmentDimensionConfig {
	filterKey: string;
	filterParam: string;
	filterType: IFilterType;
}

const SEGMENT_DIMENSION_CONFIG: Record<SegmentDimension, SegmentDimensionConfig> = {
	seniority: {
		filterKey: "seniority",
		filterParam: "job_title_to_seniority.seniority",
		filterType: "dropdown",
	},
	jobTitle: {
		filterKey: "title",
		filterParam: "prospect.title",
		filterType: "dropdownCustom",
	},
	geo: {
		filterKey: "country",
		filterParam: "prospect.country",
		filterType: "dropdown",
	},
	industry: {
		filterKey: "industry",
		filterParam: "organization.industry",
		filterType: "dropdown",
	},
};

export const buildSegmentFilter = (
	dimension: SegmentDimension,
	bucketKey: string | null,
	bucketLabel: string
): IFilterWithValues | null => {
	if (bucketKey === null || bucketKey === undefined || bucketKey === "") {
		return null;
	}

	const config = SEGMENT_DIMENSION_CONFIG[dimension];

	return {
		[config.filterKey]: {
			value: [{ id: bucketKey, title: bucketLabel }],
			type: config.filterType,
			filterParam: config.filterParam,
		},
	};
};

export const getSegmentFilterParam = (dimension: SegmentDimension): string =>
	SEGMENT_DIMENSION_CONFIG[dimension].filterParam;

/**
 * Reverse lookup: given an active-filter key (e.g. `"seniority"`, `"country"`),
 * return the UI dimension it maps to. Used to resolve chip labels and to detect
 * which dimension is constrained. Returns `null` for keys that don't belong to
 * the drill-through dimensions (defensive against unrelated filter keys).
 */
export const getDimensionForFilterKey = (filterKey: string): SegmentDimension | null => {
	for (const [dimension, config] of Object.entries(SEGMENT_DIMENSION_CONFIG) as [
		SegmentDimension,
		SegmentDimensionConfig,
	][]) {
		if (config.filterKey === filterKey) {
			return dimension;
		}
	}

	return null;
};
